import { Router } from '@angular/router';

export const SCHEDMED_ADMIN_ROUTE_SEGMENT = 'admin';

export function buildSchedMedAdminUrl(page: string): string {
  const usertype = sessionStorage.getItem('usertype');
  const stored = (localStorage.getItem('testCode') || '').trim();

  if (usertype === '1') {
    if (stored && stored !== SCHEDMED_ADMIN_ROUTE_SEGMENT) {
      return `/${stored}/${SCHEDMED_ADMIN_ROUTE_SEGMENT}/${page}`;
    }
    return `/${SCHEDMED_ADMIN_ROUTE_SEGMENT}/${page}`;
  }

  if (stored) {
    return `/${stored}/${page}`;
  }

  return `/${SCHEDMED_ADMIN_ROUTE_SEGMENT}/${page}`;
}

export function getSchedMedAdminRouteCommands(_router?: Router): string[] {
  const url = buildSchedMedAdminUrl('dashboard');
  const parts = url.split('/').filter((p) => p.length > 0);
  parts.pop();
  return parts;
}

export function getSchedMedAdminPageFromUrl(router: Router): string {
  const parts = (router.url || '').split('?')[0].split('/').filter((p) => p.length > 0);
  const adminIdx = parts.indexOf(SCHEDMED_ADMIN_ROUTE_SEGMENT);
  if (adminIdx >= 0 && parts.length > adminIdx + 1) {
    return parts[adminIdx + 1];
  }
  if (parts.length >= 2) {
    return parts[parts.length - 1];
  }
  return parts[0] || 'dashboard';
}

export function navigateToSchedMedDashboard(router: Router): void {
  router.navigateByUrl(buildSchedMedAdminUrl('dashboard'));
}

export function navigateToSchedMedAdminPage(router: Router, page: string): void {
  router.navigateByUrl(buildSchedMedAdminUrl(page));
}
